import { getTextColor } from '@Utils/cms';
import { jsonToHTML } from '@Utils/cms-rte';

function adapterCatalogHero([data]) {
  if (!data) {
    return undefined;
  }

  let img;
  const {
    accessibility,
    centered,
    image,
    mobile_image: mobileImage,
    nuance,
    visibility_layer: gradient,
  } = data;
  const footer = jsonToHTML(data.footer);
  const header = jsonToHTML(data.header);
  const mainTitle = jsonToHTML(data.main_title);

  if (mobileImage?.url) {
    img = {
      src: mobileImage.url,
      srcDesktop: image?.url,
      type: 'dam',
    };
  } else if (image?.url) {
    img = {
      src: image.url,
      type: 'dam',
    };
  }

  if (!accessibility && !footer && !header && !img && !mainTitle) {
    return undefined;
  }

  return {
    accessibility,
    centered,
    gradient,
    img,
    mention: footer,
    subhead: header,
    textColor: getTextColor(nuance?.select),
    title: mainTitle,
  };
}

export { adapterCatalogHero };
